<template>
    <div class="month-calendar">
        <p
            class="month-calendar__back-button"
            @click="backToListView"
        >
            <i
                class="list-calendar__icon fa fa-chevron-left icon is-small"
                aria-hidden="true"
            />

            {{ $t('generic.back') }}
        </p>

        <h2>{{ campsite.name }}</h2>

        <VCalendar
            class="custom-calendar max-w-full"
            v-model="dateRange"
            :is-range="true"
            :masks="masks"
        >
            <template v-slot:day-content="{ day }">
                <div class="flex flex-col h-full z-10 overflow-hidden">
                    <span class="day-label text-sm text-gray-900">{{ day.day }}</span>
                    <div class="flex-grow overflow-y-auto overflow-x-auto">
                        <p class="text-xs leading-tight rounded-sm p-1 mt-0 mb-1">
                            {{ getPriceForDay(day) }}
                        </p>
                    </div>
                </div>
            </template>
        </VCalendar>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VCalendar from 'v-calendar/lib/components/calendar.umd';
    import moment from 'moment';

    Vue.component('v-calendar', VCalendar);

    export default {
        name: 'month-calendar',

        components: {
            VCalendar,
        },
        props: {
            campsite: {
                type: Object,
                default: () => ({}),
            },
        },
        data() {
            return {
                dateRange: null,
                masks: {
                    weekdays: 'WWW',
                },
                // Just for mocking purposes, needs to get adjusted after api implementation
                // and to be used as a prop
                campsitePrices: [
                    {
                        id: 4,
                        prices: [
                            {
                                from: '2023-02-02',
                                to: '2023-02-04',
                                value: '50€',
                            },
                            {
                                from: '2023-02-05',
                                to: '2023-02-07',
                                value: '40€',
                            },
                        ]
                    },
                    {
                        id: 6,
                        prices: [
                            {
                                from: '2023-01-02',
                                to: '2023-02-04',
                                value: '50€',
                                extras: [
                                    {
                                        name: 'Extra Bett',
                                        value: '10€'
                                    },
                                    {
                                        name: 'Und noch was',
                                        value: '20€'
                                    },
                                ],
                            },
                            {
                                from: '2023-02-20',
                                to: '2023-03-07',
                                value: '40€',
                            },
                        ]
                    },
                ],
            };
        },
        computed: {
            getPricesForSelectedCampsite() {
                const prices = this.campsitePrices.find((campsitePrice) => campsitePrice.id === this.campsite.id);

                return prices || [];
            },
        },
        methods: {
            backToListView() {
                this.$emit('back');
            },
            getPriceForDay(day) {
                if(this.getPricesForSelectedCampsite.length === 0) {
                    return null;
                }

                for(let campsitePrice of this.getPricesForSelectedCampsite.prices) {
                    const startDay = moment(campsitePrice.from);
                    const endDay = moment(campsitePrice.to);
                    const currentDay = moment(day.date);

                    if(
                        currentDay.isSame(startDay) ||
                        currentDay.isSame(endDay) ||
                        currentDay.isBetween(startDay, endDay)
                    ) {
                        return campsitePrice.value;
                    }
                }

                return null;
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import './month-calendar';
</style>



// WEBPACK FOOTER //
// src/views/components/month-calendar/month-calendar.vue